import React from 'react'

import styles from './styles.module.scss'

export default () => <hr className={styles.separator} />
